export const SET_COMMUNICATION_REDUCER = "SET_CUMMUNICATION_REDUCER";

export const OTP_SENT_SUCCESS = "OTP_SENT_SUCCESS";
export const OTP_SENT_ERROR = "OTP_SENT_ERROR";
